import React, { useEffect, useState } from "react";
import { auth } from "firebase/auth";
import Navbar from "./Navbar";

import { useNavigate } from "react-router-dom";
import Signup from "./Signup";
import logo from "../assets/coin.png";
import GoogleLogin from "./GoogleLogin";
import Signout from "./Signout";

import background from "../assets/mountains_home.png";


export default function Home({user}) {

  
  

  const navigate = useNavigate();
  const goInvest = () => {
    navigate("/invest");
  };
  return (
    <div className="h-screen overflow-hidden">
      <Navbar user={user}/>
      <div className="w-full flex flex-col justify-center items-center overflow-hidden">  
        <div className="text-[#73C4FC] text-7xl m-4 mt-64 font-bold">
          The Finance Platform
        </div>
        <div className="text-[#636B90] text-3xl m-2 font-bold">
          Personal finance easy as 1,2,3!
        </div>
        <div className="text-[#9496B6] text-3xl m-2">
          Your greatest life investment, with the push of a button
        </div>
        <button
          className="bg-[#73C4FC] text-[#EEEEEE]  p-4 m-5 text-3xl rounded-lg "
          onClick={goInvest}
        >
          Recommendations
        </button>
        <div class="w-full h-full">
          <img src={background} alt="..." class="bg-fill h-full w-full" />
        </div>
      </div>
    </div>
  );
}
